import { Components, Theme } from "@mui/material";

export default {
  MuiCard: {
    styleOverrides: {
      root: {
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        borderRadius: 10,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        "&.highlighted": {
          "::before": {
            position: "absolute",
            content: "''",
            inset: 0,
            opacity: 0,
            borderRadius: 10,
            border: "double 2px transparent",
            backgroundImage: "linear-gradient(#fff, #fff), linear-gradient(180deg, rgba(33, 186, 158, 0.5) 0%, rgba(0, 175, 227, 0.5) 100%)",
            backgroundOrigin: "border-box",
            backgroundClip: "padding-box, border-box",
            transition: "opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1)"
          },
          ":hover": {
            cursor: "pointer",
            boxShadow: "0px 4px 20px 0px #00AFE233",
            "::before": {
              opacity: 1
            },
          }
        }
      },
    }
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: "20px 30px 0",
        alignItems: "start",
        zIndex: 1,
      },
      content: {
        height: "34px",
        display: "flex",
        alignItems: "center"
      },
      title: {
        display: "flex",
        textTransform: "uppercase",
        alignItems: "center",
        fontWeight: 600,
        fontSize: 12,
        letterSpacing: "0.1em"
      },
      action: {
        marginTop: "-2px",
        marginBottom: 0
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: "0 30px 30px !important",
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        justifyContent: "space-between",
        zIndex: 1,
      },
    },
  },
  MuiCardActions: {
    styleOverrides: {
      root: {
        padding: "0 30px 30px ",
        display: "flex",
        justifyContent: "end"
      },
    },
  },
} as Components<Omit<Theme, "components">>;
